<!-- src/layouts/AppLayout.vue -->
<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import AppSidebar from '@/components/layout/AppSidebar.vue'
import AppTopBar from '@/components/layout/AppTopBar.vue'
import BottomNav from '@/components/layout/BottomNav.vue'
import CommandPalette from '@/components/search/CommandPalette.vue'
import ProPaywallDialog from '@/components/modals/ProPaywallDialog.vue'
import { useAppShellStore } from '@/store/AppShellStore'

const route = useRoute()
const appShell = useAppShellStore()
// Connect, the class workspace + its detail surfaces, and student detail all
// fill the content area edge-to-edge.
const isFlushRoute = computed(
  () =>
    route.path.startsWith('/connect') ||
    route.path.startsWith('/students/') ||
    /^\/classes\/[^/]+/.test(route.path),
)

// Global ⌘K / Ctrl-K toggles the command palette from anywhere.
function onKeydown(e: KeyboardEvent) {
  if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
    e.preventDefault()
    appShell.togglePalette()
  }
}
onMounted(() => document.addEventListener('keydown', onKeydown))
onBeforeUnmount(() => document.removeEventListener('keydown', onKeydown))
</script>

<template>
  <div class="flex h-screen bg-[var(--canvas)]">
    <!-- Persistent left rail (desktop) -->
    <AppSidebar class="hidden md:flex" />

    <!-- Top bar + scrolling content -->
    <div class="flex flex-1 flex-col min-w-0">
      <AppTopBar />
      <main
        class="flex-1 overflow-y-auto"
        :class="isFlushRoute ? '' : 'p-4 md:p-6 pb-20 md:pb-6'"
      >
        <router-view />
      </main>
    </div>

    <!-- Mobile bottom navigation -->
    <BottomNav />

    <!-- ⌘K command palette + Pro paywall -->
    <CommandPalette />
    <ProPaywallDialog />
  </div>
</template>
